import { GeneralAggregatedTech } from 'src/app/models/tech/general-aggregated-tech.model';
import { ApiPagination } from 'src/app/models/api/api-pagination.model';
import { ScholasticYear } from 'src/app/models/scholastic-year.model';
import { ClassesService } from 'src/app/services/classes.service';
import { ApiError } from 'src/app/models/api/api-error.model';
import { TechService } from 'src/app/services/tech.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Component, inject } from '@angular/core';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-techs',
  templateUrl: './techs.component.html',
})
export class TechsComponent {
  private classService: ClassesService = inject(ClassesService);
  private techService: TechService = inject(TechService);
  private txt?: string = undefined;

  protected error?: ApiError = undefined;
  protected pagination?: ApiPagination;
  protected loading: boolean = true;
  protected techs: GeneralAggregatedTech[] = [];

  protected schoolYears$ = this.classService.schoolYears$;
  protected typesOptions: { value: string; label: string }[] = [
    { value: 'assignment', label: 'Assegnazione' },
    { value: 'insurance', label: 'Assicurazione' },
    { value: 'loss', label: 'Furto/Smarrimento' },
    { value: 'breaking', label: 'Guasto/Rottura' },
    { value: 'return', label: 'Restituzione' },
    { value: 'release', label: 'Riscatto' },
  ];

  protected filterForm: FormGroup = new FormGroup({
    period: new FormControl<string>('school_year'),
    school_year: new FormControl<string>(ScholasticYear.getCurrent()),
    from: new FormControl(),
    to: new FormControl(),
    types: new FormControl<string>('*'),
  });

  ngOnInit(): void {
    this.getData();
    this.filterForm.valueChanges
      .pipe(debounceTime(250))
      .subscribe(() => this.getData());
  }

  protected getTechBlockLabel(type: string | undefined): string | undefined {
    if (!type) return;
    return this.typesOptions.find((t) => t.value === type)?.label;
  }

  protected onText(event: string): void {
    this.txt = event?.toString().trim() || undefined;
    this.getData();
  }

  protected onPage(event: number): void {
    if (this.pagination) {
      this.pagination.page = event;
      this.getData();
    }
  }

  private getData(): void {
    this.loading = true;
    this.error = undefined;
    this.techService
      .getTechAggregateListing({
        page: this.pagination?.page || 0,
        limit: this.pagination?.limit || 25,
        txt: this.txt,
        schoolYear:
          this.filterForm.get('period')?.value === 'school_year'
            ? this.filterForm.get('school_year')?.value
            : undefined,
        types:
          this.filterForm.get('types')?.value !== '*'
            ? [this.filterForm.get('types')?.value]
            : undefined,
        from:
          this.filterForm.get('period')?.value === 'range'
            ? this.filterForm.get('from')?.value
            : undefined,
        to:
          this.filterForm.get('period')?.value === 'range'
            ? this.filterForm.get('to')?.value
            : undefined,
      })
      .subscribe({
        next: (data: any) => {
          this.pagination = new ApiPagination(data.pagination);
          this.techs = data?.data?.map(
            (json: any) => new GeneralAggregatedTech(json)
          );
        },
        error: (error: any) => {
          this.error = new ApiError(error);
          console.error('getTechAggregateListing - Error:', this.error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  // private parseCSV(file: any) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       this._papa.parse(file, {
  //         header: true,
  //         complete: (data) => resolve(data.data),
  //       });
  //     } catch (error) {
  //       console.error('ParseCSV Error:', error);
  //       return reject(error);
  //     }
  //   });
  // }
}
